import { Style, styled } from 'inlines'
import { useState, useEffect } from 'react'

type ImageWithFallbackProps = {
  style: Style
  src?: string
  fallback: string
  alt?: string
  onClick?: () => void
  onError?: () => void
}

export const ImageWithFallback = ({
  style,
  src,
  fallback,
  alt,
  onClick,
  onError,
}: ImageWithFallbackProps) => {
  const [hasError, setHasError] = useState(false)
  const [isLoaded, setIsLoaded] = useState(false)
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
    if (src) {
      setHasError(false)
      setIsLoaded(false)
      const img = new Image()
      img.onload = () => {
        setIsLoaded(true)
      }
      img.src = src
    }
  }, [src])

  const handleError = () => {
    onError?.()
    setHasError(true)
  }

  if (!isLoaded || hasError || !src) {
    return (
      <styled.img
        src={mounted ? fallback : undefined}
        alt={alt || ''}
        onClick={onClick}
        onError={handleError}
        draggable="false"
        style={style}
      />
    )
  }

  return (
    <styled.img
      src={src}
      alt={alt || ''}
      onClick={onClick}
      onError={handleError}
      draggable="false"
      style={{
        ...style,
      }}
    />
  )
}
